import React from "react";

const ContactoRRSS = () => {
  return (
    <div className="container my-4">
      <hr />
      <div className="rrss d-flex flex-column justify-content-between align-items-center flex-md-row">
        <div className="col-md-4 mt-3">
          <p className="mb-0 fs-4">Contáctanos a través de nuestros canales:</p>
        </div>
        <div className="col-md-4 mt-3 d-flex justify-content-center">
          <span className="mt-1 fs-2">
            <i className="fa-sharp fa-solid fa-phone"></i>
          </span>
          <p className="mx-3 mb-0 fw-bold">
            Ayuda Telefónica <br /> 600 360 3000{" "}
          </p>
        </div>
        <div className="col-md-4 mt-3 d-flex justify-content-between justify-content-md-end">
          <span className="mx-3 mx-lg-4 fs-2">
            <a href="https://www.facebook.com/FonasaChile">
              <i className="fa-brands fa-square-facebook"></i>
            </a>
          </span>
          <span className="mx-3 mx-lg-4 fs-2">
            <a href="https://twitter.com/fonasa?lang=en">
              <i className="fa-brands fa-twitter"></i>
            </a>
          </span>
          <span className="mx-3 mx-lg-4 fs-2">
            <a href="https://www.instagram.com/fonasachile">
              <i className="fa-brands fa-instagram"></i>
            </a>
          </span>
          <span className="mx-3 mx-lg-4 fs-2">
            <a href="https://www.youtube.com/channel/UCEb6BZnaMmGaDjoEGElnDMg">
              <i className="fa-brands fa-youtube"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactoRRSS;
